import { cn } from '@/lib/utils';
import { COVER_DIMENSIONS, type CoverSize } from '@/lib/coverUtils';

interface CoverImageSkeletonProps {
  size?: CoverSize;
  className?: string;
}

export function CoverImageSkeleton({ 
  size = 'md', 
  className 
}: CoverImageSkeletonProps) {
  const { container } = COVER_DIMENSIONS[size];

  return (
    <div 
      className={cn(
        'relative aspect-[2/3] overflow-hidden rounded-md shadow-sm',
        'bg-muted animate-pulse',
        container,
        className
      )}
      aria-label="Loading book cover"
    >
      {/* Optional shimmer effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shimmer" />
    </div>
  );
}